import { render } from "./PhototequeView.vue?vue&type=template&id=12bf7944"
const script = {}

import "./PhototequeView.vue?vue&type=style&index=0&id=12bf7944&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__